export const appTopBarHeight = "4rem";
export const forestTopBarHeight = "4rem";
const filtersHeightNumber = 8;
export const filtersHeight = `${filtersHeightNumber}rem`;
const searchResultsTopbarHeightNumber = 4;
export const searchResultsTopbarHeight = `${searchResultsTopbarHeightNumber}rem`;
const totalHeaderHeight = filtersHeightNumber + searchResultsTopbarHeightNumber;
export const searchResultsHeaderHeight = `${totalHeaderHeight}rem`;